<div class="modal-header">
    <h5 class="modal-title">{{ equipment?.name }} - Hareket Geçmişi</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div *ngIf="equipment?.assignmentMovements?.length > 0; else noData">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>Tarih</th>
                    <th>Gönderen</th>
                    <th>Teslim Alan</th>
                    <th>İşlemi Yapan</th>
                    <th>Hareket Türü</th>
                    <th>Açıklama</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of equipment.assignmentMovements">
                    <td>{{ item.movementDate | date:'dd.MM.yyyy' }}</td>
                    <td>{{ item.fromPerson }}</td>
                    <td>{{ item.toPerson }}</td>
                    <td>{{ item.personName }}</td>
                    <td>{{ movementTypeMap[item.movementType] }}</td>
                    <td>{{ item.description }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #noData>
        <p class="text-muted">Herhangi bir hareket kaydı bulunamadı.</p>
    </ng-template>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Kapat</button>
</div>